<template>
  <div :class="['msgBox', isChooseAi]">
  <!-- <div :class="['msgBox', isDark ? 'msgBoxDark' : '', isChooseAi ? 'chooseAi' : '', (isDark && isChooseAi) ? 'darkChooseAi' : '']"> -->
    <div class="avatar" v-if="showAvatar" @click="handle">
      <!-- 背景色+文字居中 -->
      <div class="avatarBox" v-if="msgItem.avatarText" :style="{background: msgItem.avatarText.background}">
        {{ msgItem.avatarText.text }}
      </div>
      <!-- 背景色+icon居中+未读徽标 -->
      <el-badge is-dot class="avatarBox" v-else-if="msgItem.avatarIcon">
        <div class="avatarBox iconBox">
          <i :class="msgItem.avatarIcon"></i>
        </div>
      </el-badge>
      <!-- 头像图片 -->
      <img :src="msgItem.avatar" alt="" v-else>
    </div>
    <div class="textBox">
      <div class="text" @click="handle">
        <h3>{{ msgItem.textTitle }}</h3>
        <p>
          <i class="ti-time" v-if="isShowTimeIcon"></i>
          {{ msgItem.textContent }}
        </p>
      </div>
      <!-- hover显示操作按钮 -->
      <div class="hoverAction" v-if="isHoverAction">
        <p v-if="msgItem.timeText">{{ handleTimeText }}</p>
        <div class="dropdownBox">
          <el-dropdown trigger="click" @command="showDtl">
            <span class="el-dropdown-link">
              <i class="ti-more-alt"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="minWidth: 158px">
              <el-dropdown-item 
                icon="ti-eye" 
                style="color: #212529" 
                command="show"
                v-if="isShowDialog"
              >
                查看
              </el-dropdown-item>
              <el-dropdown-item 
                :divided = "isShowDialog"
                icon="ti-trash" 
                style="color: #dc3545" 
                command="del"
              >
                删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 充值/兑换操作按钮 -->
      <div class="action" v-if="isAction">
        <el-button type="text" @click="payGood(news)">
          <span>{{ actionText }}</span>
        </el-button>
      </div>
      <!-- 充值金额文本展示 -->
      <div class="payPrice" v-if="msgItem.payPrice">
        <span>+{{ msgItem.payPrice }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CollectDtl from '../collectDtl';
import { mapMutations, mapState } from 'vuex';
import dayjs from "dayjs";

export default {
  name: 'Msg',
  components: { CollectDtl },
  props: {
    // 展示信息
    news: {
      type: Object,
      default: {}
    },
    // 是否展示操作
    isHoverAction: {
      type: Boolean,
      default: false
    },
    // 是否展示头像区域
    showAvatar: {
      type: Boolean,
      default: true
    },
    // 展示操作按钮
    isAction: {
      type: Boolean,
      default: false
    },
    // 展示时间icon
    isShowTimeIcon: {
      type: Boolean,
      default: false,
    },
    // 是否是收藏
    // isCollect: {
    //   type: Boolean,
    //   default: false,
    // },
    // 操作按钮文本
    actionText: {
      type: String,
      default: '',
    },
    // 是否有查看按钮
    isShowDialog: {
      type: Boolean,
      default: true,
    },
    // coll-收藏 noti-系统消息
    msgType: {
      type: String,
      default: '',
    },
    // news对应键名
    itemKey: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      collectDel: api.collectDel,
      // msgItem: {},
      dialogDtlVisible: false,
      msgTypes: ['coll', 'noti', 'chat'], // 可查看详情的消息/去聊天室
    }
  },
  computed: {
    ...mapState('comAbout', ['isDark']),
    ...mapState('userAbout', ['aiAssistantId']),
    // 是否是当前聊天助手
    isChooseAi() {
      const nowId = this.msgItem.aiAssistantId || this.msgItem.id
      if (this.isDark && nowId === this.aiAssistantId) {
        return 'darkChooseAi msgBoxDark';
      } else if (this.isDark) {
        return 'msgBoxDark';
      } else if (nowId === this.aiAssistantId) {
        return 'chooseAi';
      } else {
        return '';
      }
      // return nowId === this.aiAssistantId;
    },
    isMsgType() {
      return this.msgTypes.includes(this.msgType);
    },
    // 渲染对象
    msgItem() {
      const msg = Object.assign({}, this.news);
      if (Object.keys(this.itemKey).length) {
        for (const key in this.itemKey) {
          if (Object.hasOwnProperty.call(this.itemKey, key)) {
            msg[key] = this.news[this.itemKey[key]];
          }
        }
      }
      return msg;
    },
    // 处理快捷对话最后聊天时间
    handleTimeText() {
      let newText
      // const date = dayjs('2024-08-14 01:00:00');
      const date = dayjs(this.msgItem.timeText);
      // 判断是否当天
      const nowDay = date.isSame(dayjs(), 'day');
      if (nowDay) {
        newText = date.format('HH:mm');
      } else {
        newText = date.format('YY/M/D');
      }
      return newText;
    }
  },
  watch: {},
  created () {},
  mounted () {
    // this.handlerNews();
  },
  methods: {
    ...mapMutations('userAbout', ['deleteCollect']),
    // 处理news
    // handlerNews() {
    //   this.msgItem = Object.assign({}, this.news);
    //   if (Object.keys(this.itemKey).length) {
    //     for (const key in this.itemKey) {
    //       if (Object.hasOwnProperty.call(this.itemKey, key)) {
    //         this.msgItem[key] = this.news[this.itemKey[key]];
    //       }
    //     }
    //   }
    // },
    // 处理快捷对话最后聊天时间
    // handleTimeText(timeText) {
    //   const newText = timeText;
    //   return newText;
    // },
    // 查看详情
    handle() {
      // console.log(this.msgType, 111);
      if (this.isMsgType) {
        this.$emit('show', this.news);
      }
    },
    // 查看详情/删除
    showDtl(val) {
      // 是否是收藏
      // if (this.msgType === 'coll') {
      if (val === 'show') {
        this.$emit('show', this.news);
      } else if (val === 'del') {
        this.$emit('del', this.news);
      }
      // }
    },
    // 收起收藏详情
    closeDtl(){
      this.dialogDtlVisible = false;
    },
    // 充值
    payGood(item) {
      this.$emit('payGood', item);
    },
  }
}
</script>

<style scoped lang="less">
.msgBox {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, .08);
  padding: 8px 10px;
  box-sizing: border-box;
  cursor: pointer;
  .avatar {
    height: 50px;
    width: 50px;
    margin-right: 16px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .avatarBox {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-size: 19px;
      color: rgba(255, 255, 255, .8);
    }
    .iconBox {
      background: #007bff;
      i {
        font-size: 20px;
      }
    }
  }
  .textBox {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    // max-width: 100%;
    &:hover .hoverAction .dropdownBox {
        display: block;
      }
    .text {
      // max-width: 90%;
      flex-grow: 1;
      h3 {
        font-size: 15px;
        color: #0c0c0d;
        font-weight: 600;
        line-height: 1.5;
        margin: 4px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        word-break: break-all;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #aaa;
        margin-bottom: 7px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        i {
          font-size: 12px;
          padding-right: 2px;
        }
      }
    }
    .hoverAction {
      margin-top: 8px;
      text-align: right;
      flex-shrink: 1;
      // width: 50px;

      p {
        margin-top: 5px;
        width: 50px;
        font-size: 10px;
        font-weight: 500;
        color: #aaa;
      }
      .dropdownBox {
        margin-top: 3px;
        display: none;
        i {
          font-size: 18px;
          color: #999;
        }
        :global(.el-dropdown-menu__item:not(.is-disabled):hover) {
          color: #16181b;
          text-decoration: none;
          background-color: #f8f9fa;
        }
      }
    }
    .action {
      span {
        color: #007bff;
        font-size: 16px;
      }
    }
    .payPrice {
      color: #28a745;
      margin-top: 8px;
      line-height: 24px;
      text-align: right;
    }
  }
}
.msgBoxDark {
  .textBox {
    .text {
      h3 {
        color: #ddd;
      }
    }
  }
}
.darkChooseAi {
  background-color: #293145;
}
.chooseAi {
  background-color: #E0F2FF;
}
// 下拉菜单暗黑样式
.darkDropdown {
  background-color: #1a2236;
  color: #ddd;
  .el-dropdown-menu__item--divided {
    border-color: #293145;
  }
}
</style>
